import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios'
import * as apiurl from '@/store/config.js'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    pages: [],
    posts: [],
    tags: [],
    currentTags: [],
    search: '',
    searchResult: null,
    currentArticle: null
  },
  mutations: {
    setPages (state, pagesObj) {
      state.pages = pagesObj
    },
    setPosts (state, postsObj) {
      state.posts = postsObj
    },
    setTags (state, tagsObj) {
      state.tags = tagsObj
    },
    setCurrentTag (state, tag) {
      state.currentTags.push(tag)
    },
    removeClickedTag (state, tag) {
      var i = state.currentTags.indexOf(tag)
      // console.log('tag index ', i)
      state.currentTags.splice(i, 1)
    },
    setSearch (state, searchInput) {
      state.search = searchInput
      // console.log('tag index ', i)
    },
    setSearchResult (state, payload) {
      //  console.log('mutation searchRes ', payload)
      state.searchResult = payload
    },
    setClearTags (state, payload) {
      state.currentTags = []
    },
    setArticle (state, article) {
      state.currentArticle = article
    }
  },
  actions: {
    getPages (context, payLoad) {
      axios.get(apiurl.default.apiurl + 'pages?per_page=100')
        .then(function (response) {
          context.commit('setPages', response.data)
        })
        .catch(function (e) {
          this.errors.push(e)
        })
    },
    getPosts (context, payLoad) {
      axios.get(apiurl.default.apiurl + 'posts?per_page=100')
        .then(function (response) {
          context.commit('setPosts', response.data)
        })
        .catch(function (e) {
          this.errors.push(e)
        })
    },
    getTags (context, payLoad) {
      axios.get(apiurl.default.apiurl + 'tags?per_page=100')
        .then(function (response) {
          context.commit('setTags', response.data)
        })
        .catch(function (e) {
          this.errors.push(e)
        })
    },
    getClearTags (context, payLoad) {
      context.commit('setClearTags', payLoad)
    },
    getSearch (context, payLoad) {
      context.commit('setSearch', payLoad)
    },
    getSearchResult (context, payLoad) {
      // console.log('autosuggest ', payLoad)
      context.commit('setSearchResult', payLoad)
    },
    getArticle (context, payLoad) {
      // console.log('autosuggest ', payLoad)
      context.commit('setArticle', payLoad)
    }
  }
})



// WEBPACK FOOTER //
// ./src/store/index.js